import { render, staticRenderFns } from "./editTable.vue?vue&type=template&id=23b380dc&scoped=true"
import script from "./editTable.vue?vue&type=script&lang=js"
export * from "./editTable.vue?vue&type=script&lang=js"
import style0 from "./editTable.vue?vue&type=style&index=0&id=23b380dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b380dc",
  null
  
)

export default component.exports